import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {Button} from 'react-bootstrap';
import axios from 'axios';
import ContractInvoicesHistoryModal from './ContractInvoicesHistoryModal';

const InvoiceHistoryAttachmentLink = ({item, isSupplier, type}) => {
    if (!item || !item.attachment_filename) {
        return null;
    }

    const contract_url = isSupplier
        ? `/my_contracts/${item.contract_id}/invoice_history/${item.id}/download`
        : `/contracts/manage_contracts/invoice_history_uploads/${item.contract_id}/${item.id}`;

    const url = type === 'contract'
        ? contract_url
        : "/contracts/expenditures/invoice_history_uploads/" + item.expenditure_id + "/" + item.id;


    return (
        <a target="_blank" href={url}>
            <i className="fa fa-cloud-download"></i> {window.__js_contracts.download_attachment}
        </a>
    );
};

export default class ContractInvoicesHistory extends Component {
    constructor() {
        super();

        this.state = {
            history_id: 0,
            balance_formatted: "",
            balance_vat_formatted: "",
            items: []
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.editRow = this.editRow.bind(this);
        this.deleteRow = this.deleteRow.bind(this);
    }

    componentWillMount() {
        this.getHistory();
    }

    getHistory() {
        const url = this.props.type === 'contract'
            ? this.getContractUrl()
            : "/contracts/ajax/expenditures/" + this.props.contractId + "/invoice_history";

        axios
            .get(url)
            .then((response) => {
                this.setState({
                    items: response.data.invoices_history,
                    balance_formatted: response.data.balance_formatted,
                    balance_vat_formatted: response.data.balance_vat_formatted,
                });
            });
    }

    getContractUrl() {
        return this.props.is_supplier
            ? `/my_contracts/${this.props.contractId}/invoice_history`
            : `/contracts/ajax/manage_contracts/${this.props.contractId}/invoice_history`;
    }

    openModal() {
        this.setState({
            show_modal: true,
            history_id: 0
        });
    }

    closeModal() {
        this.setState({show_modal: false}, () => {
            this.getHistory();
        });
    }

    editRow(id) {
        this.setState({
            show_modal: true,
            history_id: id
        });
    }

    deleteRow(id) {
        if (confirm(window.__js_contracts.delete_entry)) {
            const url = this.props.type === 'contract'
                ? "/contracts/ajax/manage_contracts/" + this.props.contractId + "/invoice_history/" + id + "/delete"
                : "/contracts/ajax/expenditures/" + this.props.contractId + "/invoice_history/" + id + "/delete";

            axios
                .get(url)
                .then((response) => {
                    this.getHistory();
                });
        }
    }

    render() {
        let rows = [];
        let items = this.state.items;

        if (items.length > 0) {
            for (let key in items) {
                let item = items[key];
                if (items.hasOwnProperty(key)) {
                    rows.push(
                        <tr key={item.id}>
                            <td>{item.invoice_date_formatted}</td>
                            <td>{item.invoice_amount_formatted}</td>
                            <td>{item.invoice_vat_formatted}</td>
                            <td>{item.invoice_amount_vat_formatted}</td>
                            <td>
                                <InvoiceHistoryAttachmentLink
                                    item={item}
                                    isSupplier={this.props.is_supplier}
                                    type={this.props.type}
                                />
                            </td>
                            <td className={(this.props.readonly ? " hidden" : "")}>
                                <Button onClick={() => this.editRow(item.id)}
                                        bsStyle="primary"
                                        bsSize="xsmall">
                                    <i className="fa fa-pencil"></i>
                                </Button>&nbsp;
                                <Button onClick={() => this.deleteRow(item.id)}
                                        bsStyle="danger"
                                        bsSize="xsmall">
                                    <i className="fa fa-trash"></i>
                                </Button>
                            </td>
                        </tr>
                    );
                }
            }
        } else {
            let msg = window.__js_contracts.no_entries;
            if (!this.props.readonly) {
                msg = msg + " " + window.__js_contracts.add_entry_msg;
            }

            rows.push(
                <tr key="0">
                    <td colSpan="6">
                        <em>{msg}</em>
                    </td>
                </tr>
            );
        }

        return (
            <div>
                <div className={"my-form-inline" + (this.props.readonly ? " hidden" : "")}>
                    <div className="form-group">
                        <Button onClick={this.openModal}
                                bsStyle="primary">
                            <i className="fa fa-plus"></i> {window.__js_general.add}
                        </Button>
                    </div>
                </div>
                <div className="my-form-inline">
                    <div className="form-group">
                        <label>{window.__js_contracts.balance}:</label>
                        <span className="form-control-static">{this.state.balance_formatted}</span>
                    </div>
                </div>
                <div className="my-form-inline">
                    <div className="form-group">
                        <label>{window.__js_contracts.balance_with_vat}:</label>
                        <span className="form-control-static">{this.state.balance_vat_formatted}</span>
                    </div>
                </div>
                <br/>
                <div className="table-responsive">
                    <table className="table table-striped table-hover table-bordered">
                        <thead>
                        <tr>
                            <th>{window.__js_general.date}</th>
                            <th>{window.__js_contracts.amount}</th>
                            <th>{window.__js_contracts.vat_rate}</th>
                            <th>{window.__js_contracts.amount_with_vat}</th>
                            <th>{window.__js_contracts.attached_file}</th>
                            <th className={(this.props.readonly ? " hidden" : "")}>{window.__js_contracts.actions}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {rows}
                        </tbody>
                    </table>
                </div>
                <ContractInvoicesHistoryModal id={this.state.history_id}
                                              type={this.props.type}
                                              contractId={this.props.contractId}
                                              showModal={this.state.show_modal}
                                              closeCallback={this.closeModal}/>
            </div>
        );
    }
}

if (document.getElementById("contract-invoices-history")) {
    let element = document.getElementById("contract-invoices-history");
    let csrf_token = element.getAttribute("data-csrf-token");
    let contract_id = element.getAttribute("data-contract-id");
    let type = element.getAttribute("data-type");
    let readonly = (element.getAttribute("data-readonly") === "1");
    let is_supplier = (element.getAttribute("data-is-supplier") === "1");

    ReactDOM.render(
        <ContractInvoicesHistory
            csrfToken={csrf_token}
            contractId={contract_id}
            type={type}
            readonly={readonly}
            is_supplier={is_supplier}/>,
        element
    );
}